import React from 'react';

import { Route, Redirect } from 'react-router-dom';
import { useAccountContext } from './Data/accountContext';
import FormAccount from './Forms/FormAccount';
import FormIdentification from './Forms/FormIdentification';
import FormEmployment from './Forms/FormEmployment';
import FormTrustedContact from './Forms/FormTrustedContact';
import FormAssociation from './Forms/FormAssociation';
import FormTrading from './Forms/FormTrading';
import FormObjective from './Forms/FormObjective';
import FormCustomerAccountAgreement from './Forms/FormCustomerAccountAgreement';
import FormDisclosures from './Forms/FormDisclosures';
import FormSubmit from './Forms/FormSubmit';

const RegistrationRoute = ({ path, form, redirectPath }) => {
  const {
    account: { accountId },
  } = useAccountContext();

  if (!accountId) {
    return <div>Loading...</div>;
  }

  return (
    <Route
      path={path}
      render={(props) => {
        switch (form) {
          case 'account':
            return <FormAccount params={{ ...props }} />;
          case 'identification':
            return <FormIdentification params={{ ...props }} />;
          case 'employment':
            return <FormEmployment params={{ ...props }} />;
          case 'trusted-contact':
            return <FormTrustedContact params={{ ...props }} />;
          case 'association':
            return <FormAssociation params={{ ...props }} />;
          case 'trading':
            return <FormTrading params={{ ...props }} />;
          case 'objective':
            return <FormObjective params={{ ...props }} />;
          case 'customer-account-agreement':
            return <FormCustomerAccountAgreement params={{ ...props }} />;
          case 'disclosures':
            return <FormDisclosures params={{ ...props }} />;
          case 'submit':
            return <FormSubmit params={{ ...props }} />;
          default:
            return <Redirect to={redirectPath} />;
        }
      }}
    />
  );
};

export default RegistrationRoute;
